import { notify, sendRequest } from "../api"
import { updateField, getField } from 'vuex-map-fields'

const getDefaultState = () => {
    return {
        vehicle_id: '',
        logs: [],
        form_rows: []
    }
}

const getDefaultFormRow = ({vehicleId, driverId}) => ({
    vehicle_id: vehicleId,
    driver_id: driverId,
    label: '',
    value: '',
    memo: ''
})

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        RESET_STATE(state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        SET_LOG(state, payload) {
            state.logs = payload
        },
        SET_FORMS(state, payload) {
            state.form_rows = JSON.parse(JSON.stringify(payload))
        },
        ADD_FORM_ROW(state, payload) {
            // cancel if no data
            if (!payload.vehicleId || !payload.driverId) {
                notify('error', 'tambahkan kendaraan dan driver terlebih dahulu')
            } else {
                state.form_rows.push(getDefaultFormRow(payload))
            }
        },
        DELETE_FROM_ROW(state, index) {
            state.form_rows.splice(index, 1)
        },
        updateField
    },
    // can async
    actions: {
        loadLog({ commit }, { vehicleId, logCount = 50 }) {
            return sendRequest('vehicle-log/related', { vehicle_id: vehicleId, log_count: logCount }, 'get', (fetchedLogs) => commit('SET_LOG', fetchedLogs))
        }
    },
    // call variable with custom display
    getters: {
        getField
    },
    // modules
    modules: {

    }
})
